module.exports = "<app-report-table\n        [columns]=\"config?.columns || []\"\n        [rows]=\"rows\"\n        [totalRows]=\"totalRows\"\n        [showHeader]=\"config?.showHeader || false\"\n        [state]=\"state\"\n        [emptyMessage]=\"(config?.label || 'Report') + ' has no records'\">\n</app-report-table>";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/reports/report-body/report-body.component.html
// module id = 889
// module chunks = 4